import React from 'react';

const BS_Exercises = () => {
    return (
        <div>
            <h1>BS_Exercises Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Exercises;
